export default {
  /** 结算批次-批量导入 */
  IMPORT_ORDERSETTLE: '/sales/orderSettle/importExcel',
  DICT_LIST: '/maindata/dictData/listDataDictByDataType',
  /** 结算批次-获取列表 */
  LIST_ORDER_SETTLE_BY_PAGE: '/sales/orderSettle/listOrderSettleByPage',
  /** 结算批次-创建/修改 */
  SAVE_ORDER_SETTLE: '/sales/orderSettle/saveOrderSettle',
  /** 结算批次-详情查询 */
  GET_ORDER_SETTLE: '/sales/orderSettle/queryById',
  /** 结算批次-批量删除 */
  DELETE_ORDERSETTLE: '/sales/orderSettle/delOrderSettle',
  /** 结算批次-导出 */
  EXPORT_ORDERSETTLE: '/sales/orderSettle/exportExcel',
  /** 结算批次-导入关联信息 */
  IMPORT_ASSOCIATION: '/sales/orderSettle/importAssociationInfo',
  /** 结算批次-导出关联信息 */
  EXPORT_ASSOCIATION: '/sales/orderSettle/exportAllExcel',
  /** 结算批次-业务订单列表查询 */
  LIST_BUSINESS_ORDER_BY_PAGE: '/sales/businessOrder/listBusinessOrderByPage',
  /** 结算批次-业务订单列表查询-去重 */
  LIST_BUSINESS_ORDER_OTHER_BY_PAGE: '/sales/businessOrder/listBusinessOrderForOtherByPage',
  /** 结算批次-查询业务入库单列表 */
  LIST_BUSINESS_INBOUND_DETAIL: '/sales/orderSettle/listBusinessInboundDetail',
  /** 结算批次-业务入库单弹窗确定按钮-刷新所有tab页 */
  FRESH_FOR_BUSINESS_INBOUND_DETAIL: '/sales/orderSettle/freshForBusinessInboundDetail',
  /** 结算批次-查询提单列表 */
  LIST_STORAGE_LADE_TO_SETTLE_BATCH: '/sales/orderSettle/listStorageLadeToSettleBatch',
  /** 结算批次-提单弹窗确定按钮-刷新tab页-提单、收款、资金利息 */
  FRESH_FOR_STORAGE_LADE_TO_SETTLE_BATCH: '/sales/orderSettle/freshForStorageLadeToSettleBatch',
  /** 结算批次-费用明细列表 */
  LIST_EXPENSE_DETAIL: '/sales/orderSettle/listExpenseDetail',
  /** 结算批次-资金利息刷新 */
  FRESH_FOR_FUNDINTEREST: '/sales/orderSettle/freshForFundInterest',
  /** 结算批次-资金利息导出 */
  EXPORT_FUNDINTEREST: '/sales/orderSettle/exportInterestExcel',
  /** 结算批次-修改验证 */
  CHK_ORDERSETTLESLIPSTATUS: '/sales/orderSettle/checkOrderSettleSlipStatus',

  /** 结算单-获取列表 */
  LIST_ORDER_SETTLE_SLIP_BY_PAGE: '/sales/orderSettleSlip/queryPage',
  /** 结算单-创建/修改 */
  SAVE_ORDER_SETTLE_SLIP: '/sales/orderSettleSlip/saveOrderSettleSlip',
  /** 结算单-详情查询 */
  GET_ORDER_SETTLE_SLIP: '/sales/orderSettleSlip/getOrderSettleSlip',
  /** 结算单-批量删除 */
  BATCH_DELETE_ORDER_SETTLE_SLIP: '/sales/orderSettleSlip/batchDeleteOrderSettleSlip',
  /** 结算单-导出 */
  EXPORT_ORDERSETTLESLIP: '/sales/orderSettleSlip/exportExcel',
  /** 结算单-导入结算数据 */
  GET_IMPORT_DATA: '/sales/orderSettleSlip/getImportExpenseAndAssociation',
  /** 结算单-修改费用信息后重新计算合计 */
  REFRESH_EXPENSELIST: '/sales/orderSettleSlip/refreshExpenseList',

  /** 结算汇总表-列表查询 */
  LIST_ORDER_SETTLE_SUMMARY: '/sales/orderSettleSummary/listOrderSettleSummary',
  /** 结算汇总表-保存汇总表 */
  SAVE_ORDERSETTLESUMMARY: '/sales/orderSettleSummary/saveOrderSettleSummary',
  /** 结算汇总表-生成结算汇总表 */
  SETTLE_GENERATESUMMARY: '/sales/orderSettleSummary/generateSummary',
  /** 结算汇总表-生成结算汇总表 */
  IMPORT_SUMMARY_DATA_AND_ASSOCIATION: '/sales/orderSettleSummary/importSummaryDataAndAssociation',
  /** 结算汇总表-导出 */
  EXPORT_ORDERSETTLESUMMARY: '/sales/orderSettleSummary/exportExcel',
  /** 结算汇总表-计算税差 */
  CALCULATE_TAX_DIFFERENCE: '/sales/orderSettleSummary/calculateTaxDifference',
  /** 结算汇总表-计算收票金额 */
  CALCULATE_RECEIVED_TICKETS_AMOUNT: '/sales/orderSettleSummary/calculateReceivedTicketsAmount',
  /** 结算汇总表-计算理论应扣留保证金、可返保证金 */
  CALCULATE_MARGIN_MONEY:
    '/sales/orderSettleSummary/calculateDetainMarginMoneyAmountAndReturnableMarginMoney',
  /** 结算汇总表-修改数据后刷新列表数据小计合计 */
  FRESH_DATA: '/sales/orderSettleSummary/freshData',
  /** 结算汇总表-查询详情 */
  GET_SUMMARY_DETAIL: '/sales/orderSettleSummary/getOrderSettleSummaryAssociationList',
  /** 结算汇总表-修改关联数据 */
  UPDATE_SUMMARY: '/sales/orderSettleSummary/updateSettleSummaryAssociation',

  // ================================ 结算批次-资金计息-浮动利率配置 ================================
  /** 查询 */
  LIST_ORDER_SETTLE_INTEREST: '/sales/orderSettleInterest/listOrderSettleInterest',
  /** 利率配置-分页查询 */
  QUERY_SETTLRINTERESTRATECONFIG_PAGE: '/sales/orderSettleInterest/queryConfigGroupPage',
  /** 利率配置-保存 */
  SAVE_SETTLRINTERESTRATECONFIG: '/sales/orderSettleInterest/saveOrderSettleInterest',
  /** 利率配置-删除 */
  DELETE_SETTLRINTERESTRATECONFIG: '/sales/orderSettleInterest/delOrderSettleInterest',
  /** 利率配置-详情 */
  QUERY_SETTLRINTERESTRATECONFIG_BY_ID: '/sales/orderSettleInterest/queryListById',
};
